export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserView.vue?vue&type=template&id=4d74474a&"


//////////////////
// WEBPACK FOOTER
// ./src/views/UserView.vue?vue&type=template&id=4d74474a&
// module id = 539
// module chunks = 8